var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonAddFill = function SvgPersonAddFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11h-2a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 10q0-.424.287-.713A.97.97 0 0 1 16 9h2V7q0-.424.288-.713A.97.97 0 0 1 19 6q.424 0 .712.287Q20 6.576 20 7v2h2q.424 0 .712.287Q23 9.576 23 10q0 .424-.288.713A.97.97 0 0 1 22 11h-2v2q0 .424-.288.713A.97.97 0 0 1 19 14a.97.97 0 0 1-.712-.287A.97.97 0 0 1 18 13zm-9 1q-1.65 0-2.825-1.175T5 8t1.175-2.825T9 4t2.825 1.175T13 8t-1.175 2.825T9 12m-8 6v-.8q0-.85.438-1.562.437-.713 1.162-1.088a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 9 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087Q17 16.35 17 17.2v.8q0 .824-.587 1.413A1.93 1.93 0 0 1 15 20H3q-.824 0-1.412-.587A1.93 1.93 0 0 1 1 18"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonAddFill);
export { ForwardRef as ReactComponent };